import { I4BGridFilterOptions } from '@iot-platform/models/grid-engine';

export function getOperatorsForElement(rawField: any): I4BGridFilterOptions[] {
  const operators = rawField?.options?.operators;
  if (operators && Array.isArray(operators) && operators.length > 0) {
    return operators;
  }

  switch (rawField?.elementType) {
    case 'input':
      return [
        I4BGridFilterOptions.CONTAINS,
        I4BGridFilterOptions.NOT_CONTAINS,
        I4BGridFilterOptions.EQUALS,
        I4BGridFilterOptions.NOT_EQUAL,
        I4BGridFilterOptions.START_WITH,
        I4BGridFilterOptions.END_WITH,
        I4BGridFilterOptions.BLANK,
        I4BGridFilterOptions.NOT_BLANK
      ];

    case 'number':
      return [
        I4BGridFilterOptions.EQUALS,
        I4BGridFilterOptions.NOT_EQUAL,
        I4BGridFilterOptions.LESS_THAN,
        I4BGridFilterOptions.GREATER_THAN,
        I4BGridFilterOptions.LESS_THAN_OR_EQUAL,
        I4BGridFilterOptions.GREATER_THAN_OR_EQUAL
      ];

    case 'dynamic-list-single-select':
    case 'dynamic-list-multiple-selects':
    case 'select':
    case 'tree-view':
    case 'set':
    case 'timezone':
    case 'timezone-autocomplete':
      return [I4BGridFilterOptions.EQUALS, I4BGridFilterOptions.NOT_EQUAL];

    case 'date':
    case 'date-interval':
      return [I4BGridFilterOptions.GREATER_THAN_OR_EQUAL, I4BGridFilterOptions.IN_RANGE];

    default:
      return [I4BGridFilterOptions.EQUALS];
  }
}

export function getDefaultOperator(elementType: string): I4BGridFilterOptions {
  switch (elementType) {
    case 'input':
      return I4BGridFilterOptions.CONTAINS;

    case 'number':
      return I4BGridFilterOptions.EQUALS;

    case 'date':
    case 'date-interval':
      return I4BGridFilterOptions.IN_RANGE;

    case 'dynamic-list-single-select':
    case 'dynamic-list-multiple-selects':
    case 'select':
    case 'tree-view':
    case 'set':
    case 'timezone':
    case 'timezone-autocomplete':
      return I4BGridFilterOptions.EQUALS;

    default:
      return I4BGridFilterOptions.EQUALS;
  }
}

export function requiresValue(operator: I4BGridFilterOptions): boolean {
  return ![I4BGridFilterOptions.BLANK, I4BGridFilterOptions.NOT_BLANK, I4BGridFilterOptions.EMPTY].includes(operator);
}

export function isRangeOperator(operator: I4BGridFilterOptions): boolean {
  return operator === I4BGridFilterOptions.IN_RANGE;
}
